import { useMemo } from 'react';

import { Box, Typography, useTheme } from '@material-ui/core';

import { getChatSeparatorDate } from '../../utils/dates';

function ChatDateSeparator({ date }: { date: number }) {
  const theme = useTheme();
  const formattedDate = useMemo(() => {
    return getChatSeparatorDate(date);
  }, [date]);

  return (
    <Box display="flex" alignItems="center">
      <Box
        style={{
          backgroundColor: theme.palette.divider,
          padding: '4px 12px',
          borderRadius: 12,
        }}
      >
        <Typography style={{ fontSize: 12, color: theme.palette.text.secondary }}>
          {formattedDate}
        </Typography>
      </Box>
    </Box>
  );
}

export default ChatDateSeparator;
